// SEEDS
export const PRODUCT_SEED_LIST_REQUEST = 'PRODUCT_SEED_LIST_REQUEST'
export const PRODUCT_SEED_LIST_SUCCESS = 'PRODUCT_SEED_LIST_SUCCESS'
export const PRODUCT_SEED_LIST_FAIL = 'PRODUCT_SEED_LIST_FAIL'

export const PRODUCT_SEED_DETAILS_REQUEST = 'PRODUCT_SEED_DETAILS_REQUEST'
export const PRODUCT_SEED_DETAILS_SUCCESS = 'PRODUCT_SEED_DETAILS_SUCCESS'
export const PRODUCT_SEED_DETAILS_FAIL = 'PRODUCT_SEED_DETAILS_FAIL'

export const SEED_DELETE_REQUEST = 'SEED_DELETE_REQUEST'
export const SEED_DELETE_SUCCESS = 'SEED_DELETE_SUCCESS'
export const SEED_DELETE_FAIL = 'SEED_DELETE_FAIL'

export const SEED_CREATE_REQUEST = 'SEED_CREATE_REQUEST'
export const SEED_CREATE_SUCCESS = 'SEED_CREATE_SUCCESS'
export const SEED_CREATE_FAIL = 'SEED_CREATE_FAIL'
export const SEED_CREATE_RESET = 'SEED_CREATE_RESET'

export const SEED_UPDATE_REQUEST = 'SEED_UPDATE_REQUEST'
export const SEED_UPDATE_SUCCESS = 'SEED_UPDATE_SUCCESS'
export const SEED_UPDATE_FAIL = 'SEED_UPDATE_FAIL'
export const SEED_UPDATE_RESET = 'SEED_UPDATE_RESET'


// LEND MACHINES
export const PRODUCT_MACHINE_LIST_REQUEST = 'PRODUCT_MACHINE_LIST_REQUEST'
export const PRODUCT_MACHINE_LIST_SUCCESS = 'PRODUCT_MACHINE_LIST_SUCCESS'
export const PRODUCT_MACHINE_LIST_FAIL = 'PRODUCT_MACHINE_LIST_FAIL'

export const PRODUCT_MACHINE_DETAILS_REQUEST = 'PRODUCT_MACHINE_DETAILS_REQUEST'
export const PRODUCT_MACHINE_DETAILS_SUCCESS = 'PRODUCT_MACHINE_DETAILS_SUCCESS'
export const PRODUCT_MACHINE_DETAILS_FAIL = 'PRODUCT_MACHINE_DETAILS_FAIL'

export const MACHINE_DELETE_REQUEST = 'MACHINE_DELETE_REQUEST'
export const MACHINE_DELETE_SUCCESS = 'MACHINE_DELETE_SUCCESS'
export const MACHINE_DELETE_FAIL = 'MACHINE_DELETE_FAIL'

export const MACHINE_CREATE_REQUEST = 'MACHINE_CREATE_REQUEST'
export const MACHINE_CREATE_SUCCESS = 'MACHINE_CREATE_SUCCESS'
export const MACHINE_CREATE_FAIL = 'MACHINE_CREATE_FAIL'
export const MACHINE_CREATE_RESET = 'MACHINE_CREATE_RESET'

export const MACHINE_UPDATE_REQUEST = 'MACHINE_UPDATE_REQUEST'
export const MACHINE_UPDATE_SUCCESS = 'MACHINE_UPDATE_SUCCESS'
export const MACHINE_UPDATE_FAIL = 'MACHINE_UPDATE_FAIL'
export const MACHINE_UPDATE_RESET = 'MACHINE_UPDATE_RESET'

// CONSUMER
export const CONSUMER_PRODUCT_LIST_REQUEST = 'CONSUMER_PRODUCT_LIST_REQUEST'
export const CONSUMER_PRODUCT_LIST_SUCCESS = 'CONSUMER_PRODUCT_LIST_SUCCESS'
export const CONSUMER_PRODUCT_LIST_FAIL = 'CONSUMER_PRODUCT_LIST_FAIL'

export const CONSUMER_PRODUCT_DETAILS_REQUEST = 'CONSUMER_PRODUCT_DETAILS_REQUEST'
export const CONSUMER_PRODUCT_DETAILS_SUCCESS = 'CONSUMER_PRODUCT_DETAILS_SUCCESS'
export const CONSUMER_PRODUCT_DETAILS_FAIL = 'CONSUMER_PRODUCT_DETAILS_FAIL'

export const CONSUMER_DELETE_REQUEST = 'CONSUMER_DELETE_REQUEST'
export const CONSUMER_DELETE_SUCCESS = 'CONSUMER_DELETE_SUCCESS'
export const CONSUMER_DELETE_FAIL = 'CONSUMER_DELETE_FAIL'

export const CONSUMER_CREATE_REQUEST = 'CONSUMER_CREATE_REQUEST'
export const CONSUMER_CREATE_SUCCESS = 'CONSUMER_CREATE_SUCCESS'
export const CONSUMER_CREATE_FAIL = 'CONSUMER_CREATE_FAIL'
export const CONSUMER_CREATE_RESET = 'CONSUMER_CREATE_RESET'

export const CONSUMER_UPDATE_REQUEST = 'CONSUMER_UPDATE_REQUEST'
export const CONSUMER_UPDATE_SUCCESS = 'CONSUMER_UPDATE_SUCCESS'
export const CONSUMER_UPDATE_FAIL = 'CONSUMER_UPDATE_FAIL'
export const CONSUMER_UPDATE_RESET = 'CONSUMER_UPDATE_RESET'

// Reviews
export const PRODUCT_CREATE_REVIEW_REQUEST = 'PRODUCT_CREATE_REVIEW_REQUEST'
export const PRODUCT_CREATE_REVIEW_SUCCESS = 'PRODUCT_CREATE_REVIEW_SUCCESS'
export const PRODUCT_CREATE_REVIEW_FAIL = 'PRODUCT_CREATE_REVIEW_FAIL'
export const PRODUCT_CREATE_REVIEW_RESET = 'PRODUCT_CREATE_REVIEW_RESET'